import React from "react";
import img_src from "@/assets/images/404.png";
function Page404(){
    return (
    <div style={{ width: '100%',
        boxSizing: 'border-box',
        padding: '0 10%',
        paddingTop: '5%',
        textAlign: 'center',
        fontSize: 0
    }}>
        <img style={{
            display: 'inline-block',
            width: '50%',
        }} src={img_src} alt="404" />
    </div>)
}
export default Page404;